import Button from '@atlaskit/button';
import React, { FC, memo } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import Lozenge from '@atlaskit/lozenge';
import { Box, Inline, media, Text, xcss } from '@atlaskit/primitives';

const contentHeaderStyles = xcss({
  paddingBottom: 'space.200',
});

const descriptionStyles = xcss({
  display: 'none',
  [media.above.xs]: { display: 'flex' },
});

const selectLabelStyles = xcss({
  color: 'color.text.subtle',
  whiteSpace: 'nowrap',
});

interface OwnProps {
  text: string | undefined;
  onClickAll: () => void;
  onClickNone: () => void;
  groupKey: string | undefined;
}

const ContentHeader: FC<OwnProps> = ({ text, onClickAll, onClickNone, groupKey }) => {
  const { translate, keyWithCallout } = useTranslation();
  const calloutText = translate(keyWithCallout(groupKey as string));

  return (
    <Inline xcss={contentHeaderStyles} space={'space.200'} spread={'space-between'} alignBlock={'baseline'}>
      <div>
        <Box xcss={descriptionStyles}>
          <Text size={'large'}>
            {!calloutText.startsWith(groupKey as string) ? (
              <span>
                <Lozenge isBold>{calloutText}</Lozenge>
                <span> </span>
              </span>
            ) : null}
            {translate(text || '')}
          </Text>
        </Box>
      </div>
      <Inline space={'space.100'} alignBlock={'baseline'}>
        <Box xcss={selectLabelStyles}>{translate(translationKeys.SELECT_LABEL)}</Box>
        <Button testId={'dynamicConfigElementsGroupSelectAllButton'} appearance={'subtle'} onClick={onClickAll}>
          {translate(translationKeys.SELECT_ALL_BUTTON_LABEL)}
        </Button>
        <Button testId={'dynamicConfigElementsGroupSelectNoneButton'} appearance={'subtle'} onClick={onClickNone}>
          {translate(translationKeys.SELECT_NONE_BUTTON_LABEL)}
        </Button>
      </Inline>
    </Inline>
  );
};

export default memo(ContentHeader);
